var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", "max-width": "420" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "text-subtitle-1" }, [
            _vm._v(_vm._s(_vm.$t("message.flex.overtimeRegistered"))),
          ]),
          _c("v-divider"),
          _c("v-card-text", { staticClass: "pt-4 pb-2" }, [
            _c(
              "div",
              { staticClass: "d-flex justify-space-between body-2 mb-1" },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("message.flex.overtime")))]),
                _c("span", { staticClass: "font-weight-medium" }, [
                  _vm._v(_vm._s(_vm.hm(_vm.totals.overtimeMinutes))),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-space-between body-2 mb-1" },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("message.flex.toFlexAccount"))),
                ]),
                _c("span", { staticClass: "font-weight-medium" }, [
                  _vm._v(_vm._s(_vm.hm(_vm.totals.flexMinutes))),
                ]),
              ]
            ),
            _c("div", { staticClass: "d-flex justify-space-between body-2" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("message.flex.paidSupplement"))),
              ]),
              _c("span", { staticClass: "font-weight-medium" }, [
                _vm._v(_vm._s(_vm.hm(_vm.totals.supplementMinutes))),
              ]),
            ]),
          ]),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "flex-wrap" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    id: "flexChoiceFlex",
                    loading: _vm.saving === "flex",
                    disabled: !!_vm.saving,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.choose("flex")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.flex.sendToFlex")))]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    id: "flexChoicePayout",
                    loading: _vm.saving === "payout",
                    disabled: !!_vm.saving,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.choose("payout")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.flex.payOut")))]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    small: "",
                    id: "flexChoiceLater",
                    disabled: !!_vm.saving,
                  },
                  on: { click: _vm.later },
                },
                [_vm._v(_vm._s(_vm.$t("message.flex.decideLater")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }